import React from "react";
import { Link } from "react-router-dom";
import { Card, CardTitle } from "reactstrap";
import { useVsiAppContext } from "../stores/VsiApp";
import themeStyles from "../utils/themeStyles";
import { withErrorBoundary } from "../boundaries/withErrorBoundary";
import GeneralErrorBoundary from "../boundaries/GeneralErrorBoundary";

function SettingsCard ({ path, title, icon }) {
    const { theme } = useVsiAppContext();

 return (
	 <Link to={path} style={{ textDecoration: "none" }}>
		 <Card className={`my-3 p-2 nav-card settings-card-${theme}`} style={{ color: themeStyles[theme].textColor }}>
			 <CardTitle className="fw-bold">
				 {title}{" "}<i className={icon}></i>
			 </CardTitle>
		 </Card>
	 </Link>
 )
}

export default withErrorBoundary(SettingsCard, GeneralErrorBoundary);
